import { Grid } from '@material-ui/core';
import { Cancel, CheckCircle, ChevronRight, Description, Group, School, Search, Send, SendRounded } from '@material-ui/icons';
import GroupIcon from '@material-ui/icons/Group';
import { getInfosDashboard, getTeams, getDefaultTeamMembersByBusiness } from '@webapps/business';
import {
  Button,
  TextField,
  useAuth,
  useQuery,
  useRouter,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';

import Team from 'components/Icons/Team';
import Modal, { default as ModalStep } from 'components/Modal';
import { ROUTES_PATH } from 'config/constants';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory, useLocation } from 'react-router-dom';

import InviteStudent from './Components/InviteStudent';
import NewTeams from './Components/NewTeams';
import Result from './Components/Result';
import Information from 'components/Icons/Information';
import CvTheque from 'components/Icons/CvTheque';

const TeamBusiness = () => {
  const {
    classes,
    css,
    theme: { spacing },
  } = useStyles(styles);
  const { idUser } = useAuth();

  const [page, setPage] = useState(1);
  const [keyword, setKeyword] = useState('');
  const location = useLocation();
  const [openCreateClasses, setOpenCreateClasses] = useState(false);
  const [openInviteStudents, setOpenInviteStudents] = useState(false);
  const [absenceModalOpen, setAbsenceModalOpen] = useState(false);
  const { push } = useRouter();
  const history = useHistory()
  const { checkPermissions, isPremium } = useAuth();
  
  const { data: info = "fetching" } = useQuery(getDefaultTeamMembersByBusiness, {
    key: ['defaultTeam', idUser],
    variables: { id: idUser },
  });

  useEffect(() => {
    if(!info){
      if(isPremium !== null){
        checkPermissions();
      }
    }
  } , [isPremium, info]);

  const {
    // status: load,
    data: { content: teams = [], totalElements } = {},
    refetch,
    // isFetching,
  } = useQuery(getTeams, {
    key: ['teams', page + idUser + keyword],
    variables: { keyword, id: idUser, page: page - 1, size: 12 },
    keepPreviousData: true,
    staleTime: 5000,
  });

  useEffect(() => {

    if (location?.state?.openInviteStudents) {
      if (totalElements > 0) {
        setOpenInviteStudents(true); // Définir l'état local à `true`
        // history.replace(location.pathname, undefined); 
        history.replace(location.state, undefined); // Supprime `state` mais garde la même URL

      }
    }
  }, [location, totalElements]);


  const handlePaginationChange = (newPage) => {
    setPage(newPage);
  };

  const handleOpenCreateClasses = () => {
    setOpenCreateClasses(true);
  };

  const handleCloseCreateClasses = () => {
    setOpenCreateClasses(false);
  };

  const handleOpenInviteStudents = () => {
    setOpenInviteStudents(true);
  };

  const handleCloseInviteStudents = () => {
    setOpenInviteStudents(false);
  };

  const searchKeyword = (e) => {
    setKeyword(e.target.value);
    setPage(1);
  };

  const goToListInviteStudent = () => {
    push(ROUTES_PATH.BUSINESS_INVITE_STUDENT);
  };

  const goToStudentClassHistorique = () => {

    push(ROUTES_PATH.BUSINESS_STUDENT_HISTORIQUE, {
      params: {
        id: "255255484848"
      }
    });
  };

  if (!isPremium && !info) {
    return <div></div>;
  }

  return (
    <div className={classes.container}>
      <div
        className={css({
          display: 'flex',
          flexDirection: 'column',
          height: totalElements > 0 ? '100%' : 'calc(100vh - 186px - 53px)',
          '@media screen and (max-width: 768px)': {
            height: '100%',
          },
        })}
      >
        <div className={classes.containerSearch}>
          {isPremium && (
          <>
          <div
            className={css({
              display: 'flex',
              flexWrap: 'wrap',
              gap: spacing(2), // espace entre les éléments, ajustable selon le design
              '@media (max-width: 768px)': {
                flexDirection: 'column', // empiler en colonne pour petits écrans
                width: '100%',
              },
            })}
          >
            <div
              className={
                css({
                  display: 'flex',
                  gap: spacing(2),
                  '@media (max-width:768px)': {
                    width: '100%',
                  },
                })
              }
            >

              <div
                className={css({
                  flexGrow: 1,
                  '@media (max-width:768px)': {
                    flexGrow: 1,
                    width: '100%',
                  },
                })}
              >

                <TextField
                  label="Nom de l'équipe"
                  onChange={(e) => searchKeyword(e)}
                  size="small"
                  variant="outlined"
                  endAdornment={<Search style={{ color: '#5D75A8' }} />}
                  borderRadius={400}
                  fullWidth
                />
              </div>
            </div>

            <Button
              className={css({
                color: '#5D75A8',
                backgroundColor: '#F3F7FF',
                border: '1px solid #C0D9FF',
                display: 'flex',
                fontWeight: 500,
                display: 'flex',
                justifyContent: 'space-between',
                '&:hover': { border: '1px solid #C0D9FF', backgroundColor: '#F3F7FF' },
                '@media only screen and (max-width:1920px)': {
                  fontSize: '13.500px',
                },
                '@media only screen and (max-width:1600px)': {
                  fontSize: '13.5000px',
                },
              })}
              color="primary"
              variant="outlined"
              onClick={goToListInviteStudent}
            >
              Historique des invitations <ChevronRight />
            </Button>

            <Button
              className={css({
                color: '#5D75A8',
                backgroundColor: '#F3F7FF',
                border: '1px solid #C0D9FF',
                display: 'flex',
                fontWeight: 500,
                justifyContent: 'space-between',
                '&:hover': { border: '1px solid #C0D9FF', backgroundColor: '#F3F7FF' },
                '@media only screen and (max-width:1920px)': {
                  fontSize: '13.500px',
                },
                '@media only screen and (max-width:1600px)': {
                  fontSize: '13.5000px',
                },
              })}
              color="primary"
              variant="outlined"
              onClick={goToStudentClassHistorique}
            >
              Historique des sorties <ChevronRight />
            </Button>
            <Button
              className={[classes.button, classes.buttonHover, css({
                display: 'none',
                '@media (max-width:1249px)': {
                  display: 'flex'
                },
                '@media only screen and (max-width:1920px)': {
                  fontSize: '15.00px',
                },
                '@media only screen and (max-width:1600px)': {
                  fontSize: '14.00px',
                },
                '@media only screen and (max-width:768px)': {
                  flexGrow: 1,
                },
                backgroundColor: 'rgb(192, 217, 255)!important',
              })]}
              color="primary"
              startIcon={<Send />}
              // fullWidth
              onClick={handleOpenInviteStudents}
              variant="outlined"
              style={{
                border: '1px solid #0060F9',
                fontWeight: 600,

                backgroundColor: 'white',

              }}
            >
              <FormattedMessage id="school.classes.research.invitButton" />
            </Button>

            <Button
              className={[classes.button, css({
                display: 'none',
                '@media (max-width:1249px)': {
                  display: 'flex'
                },
                '@media only screen and (max-width:1920px)': {
                  fontSize: '15.00px',
                },
                '@media only screen and (max-width:1600px)': {
                  fontSize: '14.00px',
                },
                '@media only screen and (max-width:768px)': {
                  flexGrow: 1,
                },
              })
              ]}
              color="primary"
              // fullWidth
              onClick={handleOpenCreateClasses}
              variant="contained"
              disableElevation
              style={{
                fontWeight: 600,
              }}
            >
              <FormattedMessage id="business.teams.research.newClassButton" />
            </Button>
          </div>
          <div className={
              css({
                display: 'flex',
                '@media (max-width:1249px)': {
                  display: 'none'
                },
                gap: spacing(2),
                '@media (max-width:768px)': {
                  width: '100%',
                  backgroundColor: 'red'
                },
                '@media (max-width:768px)': {
                  flexDirection: 'column',
                },
              })
            }
          >
            <Button
              className={[classes.button, classes.buttonHover, css({
                '@media only screen and (max-width:1920px)': {
                  fontSize: '15.00px',
                },
                '@media only screen and (max-width:1600px)': {
                  fontSize: '14.00px',
                },
                '@media only screen and (max-width:768px)': {
                  flexGrow: 1,
                },
                backgroundColor: 'rgb(192, 217, 255)!important',
              })]}
              color="primary"
              startIcon={<Send />}
              // fullWidth
              onClick={handleOpenInviteStudents}
              variant="outlined"
              style={{
                border: '1px solid #0060F9',
                fontWeight: 600,

                backgroundColor: 'white',

              }}
            >
              <FormattedMessage id="school.classes.research.invitButton" />
            </Button>

            <Button
              className={[classes.button, css({
                '@media only screen and (max-width:1920px)': {
                  fontSize: '15.00px',
                },
                '@media only screen and (max-width:1600px)': {
                  fontSize: '14.00px',
                },
                '@media only screen and (max-width:768px)': {
                  flexGrow: 1,
                },
              })
              ]}
              color="primary"
              // fullWidth
              onClick={handleOpenCreateClasses}
              variant="contained"
              disableElevation
              style={{
                fontWeight: 600,
              }}
            >
              <FormattedMessage id="business.teams.research.newClassButton" />
            </Button>
          </div>
          </>
          )}
        </div>
        <Grid item xs={12}>
          <Result
            onPaginationChange={handlePaginationChange}
            page={page}
            refetch={refetch}
            teams={teams}
            totalElements={totalElements}
            addStudent={handleOpenInviteStudents}
          />
        </Grid>
      </div>
      <Modal
        nbStep={1}
        onCancel={handleCloseCreateClasses}
        open={openCreateClasses}
        step={1}
        title="Formulaire de création d’équipe"
        subTitle="Créez votre équipe et inviter des étudiants à rejoindre votre équipe depuis différentes manières (Depuis votre équipe ou d’une affiliation)"
        withStep={false}
      >
        <NewTeams close={handleCloseCreateClasses} refetch={refetch} />
      </Modal>
      <ModalStep
        onCancel={handleCloseInviteStudents}
        open={openInviteStudents}
        title="Formulaire d’invitation à rejoindre une équipe"
        // subTitle="Indiquez les informations nécessaires à l’invitation"
        withStep={false}
      >
        <div className={css({ display: 'flex', flexDirection: 'row' })}>
          <span>
            <Information className={css({ color: '#0060F9', height: 20, width: 20, marginRight: 10 })} />
          </span>
          <div className={css({ fontSize: 14, color: 'rgba(0, 0, 0, 0.87)' })}>
            Indiquez les informations nécessaires à l’invitation
          </div>
        </div>
        <InviteStudent close={handleCloseInviteStudents} />
      </ModalStep>
    </div >
  );
};

const styles = ({ spacing }) => ({
  container: {
    height: '100%',
    lineHeight: '100%',
  },
  paper: {
    padding: spacing(2),
  },
  searchContainer: {
    display: 'flex',
  },
  buttonOutlined: {
    border: '1px solid #0060F9',
    backgroundColor: 'white',
    '&:hover': {
      border: '1px solid #0060F9',
      filter: 'brightness(0.9)',
      backgroundColor: '#ffffffe6',
    },
    width: '100%',
    '@media only screen and (max-width:768px)': {
      // marginBottom: spacing(2.5),
      width: '100%',
    },
  },
  containerSearch: {
    background: 'white',
    display: 'flex',
    gap: spacing(2),
    justifyContent: 'space-between',
    borderRadius: '10px 10px 0 0',
  },
  buttonHover: {
    "&:hover": {
      backgroundColor: "#0060F9!important",
      color: "white!important",
    },
  },
});

export default TeamBusiness;
